import React from 'react'
import { SingleAnswer, Step } from '../../components'

const DESCRIPTION = {
  key: 'role_description',
  trackingKey: 'role',
  question: 'What best describes your role?',
  choices: [
    { icon: '💼', text: 'Executive', value: 'executive' },
    { icon: '👤', text: 'Manager', value: 'manager' },
    { icon: '📦', text: 'Product Manager', value: 'product_manager' },
    { icon: '‍💻', text: 'Engineer', value: 'engineer' },
    { icon: '✏️', text: 'Designer', value: 'designer' },
    { icon: '🔎', text: 'Consultant', value: 'consultant' },
    { text: 'Other', value: 'other' }
  ]
}

export const OtherRoleDescription = ({ index }) => {
  return (
    <Step
      index={index}
      trackingKey={DESCRIPTION.trackingKey}
      itemsCount={DESCRIPTION.choices.length}
      title={DESCRIPTION.question}
      subtitle='Select one (Required)'
    >
      {DESCRIPTION.choices.map(({ icon, text, value }) => (
        <SingleAnswer
          key={`${text}-${value}`}
          question={DESCRIPTION.question}
          surveyKey={DESCRIPTION.key}
          text={text}
          icon={icon}
          value={value}
        />
      ))}
    </Step>
  )
}
